import { Link } from "react-router-dom";
import "./SpeakingClubBanner.css";
import speakingClubMascot from "./speakingClubMascot.svg";
import laptop from "./laptop.svg";
import useBreakpoint from "hooks/useBreakpoint";
import TalaeraRoutes from "components/routes/TalaeraRoutes";
import useUser from "hooks/useUser";
import { isUserStudent } from "services/authUtil";
import { useTranslation } from "react-i18next";

function SpeakingClubBanner() {
  const { t } = useTranslation();
  const { tabletAndBelow } = useBreakpoint();

  const user = useUser(true);
  if (!isUserStudent(user) || !user.features.workshops) {
    return null;
  }

  const cta = (
    <Link className="speaking-club-banner__cta" to={TalaeraRoutes.SPEAKING_CLUB.path}>
      {t("SpeakingClub.Banner.findSessions")}
    </Link>
  );

  const description = (
    <div className="speaking-club-banner__description">
      {t("SpeakingClub.Banner.description")}
    </div>
  );

  return (
    <div className="speaking-club-banner">
      <div className="speaking-club-banner__content">
        {tabletAndBelow ? (
          <>
            <div className="speaking-club-banner__text-container">
              <div className="speaking-club-banner__title">
                {t("SpeakingClub.Banner.title")}
              </div>
              {description}
              {cta}
            </div>
            <div className="speaking-club-banner__mascots">
              <img src={speakingClubMascot} alt={t("SpeakingClub.Banner.mascotAlt")} />
              <img src={laptop} alt={t("SpeakingClub.Banner.laptopAlt")} />
            </div>
          </>
        ) : (
          <>
            <img src={speakingClubMascot} alt={t("SpeakingClub.Banner.mascotAlt")} />
            <div className="speaking-club-banner__text-container">
              <div className="speaking-club-banner__title">
                {t("SpeakingClub.Banner.title")} &nbsp;
                {cta}
              </div>
              {description}
            </div>
            <img src={laptop} alt={t("SpeakingClub.Banner.laptopAlt")} />
          </>
        )}
      </div>
    </div>
  );
}

export default SpeakingClubBanner;
